export default [
  //    - Hospedajes reports
  {
    path: "/administration/hospedajes-reports",
    name: "foravila-administration-hospedajes-reports",
    component: () =>
      import("@/views/administration/hospedajes-reports/HospedajesReports.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Control d'hospedajes",
      breadcrumb: [
        { text: "Administració" },
        { text: "Hospedajes", active: true },
      ],
    },
  },
  //    - AEAT reports
  {
    path: "/administration/aeat-reports",
    name: "foravila-administration-aeat-reports",
    component: () =>
      import("@/views/administration/aeat-reports/AEATReports.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Control d'informes AEAT",
      breadcrumb: [{ text: "Administració" }, { text: "AEAT", active: true }],
    },
  },
  //    - VUD numbers
  {
    path: "/administration/vud/numbers",
    name: "foravila-administration-vud-numbers",
    component: () =>
      import("@/views/administration/vud-reports/VUDNumbers.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Ventanilla Única Digital",
      breadcrumb: [{ text: "Administració" }, { text: "VUD" }, { text: "Registres", active: true }],
    },
  },
  //    - VUD reports
  {
    path: "/administration/vud/reports",
    name: "foravila-administration-vud-reports",
    component: () =>
      import("@/views/administration/vud-reports/VUDReports.vue"),
    meta: {
      action: "manage",
      resource: "all",
      pageTitle: "Ventanilla Única Digital",
      breadcrumb: [{ text: "Administració" }, { text: "VUD" }, { text: "Enviaments", active: true }],
    },
  },
];
